import React, { useState, useEffect } from 'react';
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Button, TextField } from '@mui/material';
import { createBlog, deleteBlog, fetchBlog } from '../api/blogAPI';
import { toast } from 'react-toastify';

function Blog() {
    const [blogs, setBlogs] = useState([]);
    const [name, setName] = useState('');
    const [content, setContent] = useState('');

    // Fetch all blogs on component mount
    useEffect(() => {
        fetchBlogs();
    }, []);

    const fetchBlogs = async () => {
        const response = await fetchBlog();
        setBlogs(response);
    };

    const addBlog = async () => {
        const res = await createBlog({ name, content })
        if (res?.message) {
            toast.success(res.message)
        } else {
            toast.error('Issue on creating blog')
        }
        setName('');
        setContent('');
        fetchBlogs();
    };

    const remove = async (id) => {
        const res = await deleteBlog(id)
        if (res?.message) {
            toast.success(res.message)
        } else {
            toast.error('Issue on deleting blog')
        }
        fetchBlogs();
    };

    return (
        <div>
            <h2>Add Blog</h2>
            <div style={{ width: '100%', gap: 5, display: 'flex' }}>
                <TextField sx={{ width: '20%' }} label="Name" value={name} onChange={(e) => setName(e.target.value)} />
                <TextField label="Content" sx={{ width: '80%' }} value={content} onChange={(e) => setContent(e.target.value)} multiline rows={2} fullWidth />
            </div>
            <Button onClick={addBlog} variant="contained" color="primary">Add Blog</Button>

            <h2>Blog List</h2>
            <TableContainer>
                <Table>
                    <TableHead>
                        <TableRow>
                            <TableCell>Name</TableCell>
                            <TableCell>Content</TableCell>
                            <TableCell>Actions</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {blogs.length > 0 && blogs.map((blog) => (
                            <TableRow key={blog.id}>
                                <TableCell>{blog.name}</TableCell>
                                <TableCell style={{ maxHeight: 100, overflow: 'auto' }}>
                                    <div style={{ maxHeight: '100px', overflowY: 'auto' }}>{blog.content}</div>
                                </TableCell>
                                <TableCell>
                                    <Button onClick={() => remove(blog['_id'])} color="secondary">Delete</Button>
                                </TableCell>
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>
            </TableContainer>
        </div>
    );
}

export default Blog;
